var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Datatable',{attrs:{"entity":"QrPayRequest","parameters":{company: _vm.$route.query.company},"onRowClick":_vm.onRowClick,"rowActions":[{text: 'datatable.display', method: _vm.onRowClick}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }